/**
 * localStorage that never throws (private mode, blocked storage). What lives
 * here is only what must survive the trip to a payment page and back:
 *
 *   csrf     the CSRF token issued with the guest session (useless without the
 *            HttpOnly session cookie, which is never readable here)
 *   visit    the visit in progress, so returning from the payment page resumes
 *   qr       that visit's machine code, so changing the payment method can
 *            reopen the visit without scanning again
 *   channel  the customer's preferred payment method
 *   locale   the chosen language
 */
const PREFIX = "aseed.";

export type StoreKey = "csrf" | "visit" | "qr" | "channel" | "locale";

export const store = {
  get(key: StoreKey): string | null {
    try {
      return globalThis.localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },
  set(key: StoreKey, value: string): void {
    try {
      globalThis.localStorage.setItem(PREFIX + key, value);
    } catch {
      /* in-memory only for this page */
    }
  },
  remove(key: StoreKey): void {
    try {
      globalThis.localStorage.removeItem(PREFIX + key);
    } catch {
      /* ignore */
    }
  },
};
